/*
 * @Author       : zhangbobo01 zhangbobo01@baidu.com
 * @Date         : 2022-11-17 21:06:48
 * @LastEditors  : zhangbobo01 zhangbobo01@baidu.com
 * @LastEditTime : 2023-02-13 18:18:08
 * @FilePath     : /ticket-plat-frontend/src/common/constants.ts
 */
import i18n from '@/i18n';
import type {AllowedButtons, PopoverDOM} from 'driver.js';

export enum PERMISSION {
    FULL_CONTROL = 'FULL_CONTROL', // 读写账号下全部工单
    USER_CONTROL = 'USER_CONTROL', // 读写登录子用户id下全部工单
    DENY = 'DENY', // 禁止访问
    INITIAL = 'INITIAL', // 初始状态
}

export enum LOCAL {
    en = 'en',
    zh = 'zh-CN',
}

export const TICKET_STATUS = [
    {value: 'HANDLING', text: i18n.t('chu-li-zhong')},
    {value: 'WAITING_FOR_FEEDBACK', text: i18n.t('dai-fan-kui')},
    {value: 'WAITING_FOR_CONFIRM', text: i18n.t('dai-que-ren')},
    {value: 'FINISHED', text: i18n.t('yi-wan-cheng')},
    {value: 'CANCELED', text: i18n.t('yi-che-xiao')},
];

export const TICKET_STATUS_FOR_ICON_MAP = {
    HANDLING: 'process',
    CANCELED: 'waiting',
    FINISHED: 'success',
    WAITING_FOR_FEEDBACK: 'warning',
    WAITING_FOR_CONFIRM: 'warning',
};

export const FINISHED_STATUS = [
    'FINISHED',
    'CANCELED',
];

export const UPLOAD_FILE_TYPES = [
    'jpg',
    'png',
    'jpeg',
    'bmp',
    'gif',
    'pdf',
    'txt',
    'doc',
    'docx',
    'ini',
    'conf',
    'eml',
    'xls',
    'xlsx',
    'rar',
    'zip',
    '7z',
    'mp4',
];

export const UPLOAD_IMAGE_TYPES = ['jpg', 'jpeg', 'png', 'bmp', 'gif'];

export const CUSTOMER_PRIORITY = ['C0', 'C1', 'C2', 'C3'];

export const AREAS_MAP: any = {
    bj: {id: 'bj', text: i18n.t('hua-bei-bei-jing')},
    bd: {id: 'bd', text: i18n.t('hua-bei-bao-ding')},
    cd: {id: 'cd', text: i18n.t('xi-nan-cheng-du')},
    gz: {id: 'gz', text: i18n.t('hua-nan-guang-zhou')},
    su: {id: 'su', text: i18n.t('hua-dong-su-zhou')},
    fsh: {id: 'fsh', text: i18n.t('hua-dong-shang-hai')},
    fwh: {id: 'fwh', text: i18n.t('jin-rong-hua-zhong-wu-han')},
    hkg: {id: 'hkg', text: i18n.t('zhong-guo-xiang-gang')},
    sin: {id: 'sin', text: i18n.t('xin-jia-po')},
};

export const INSTANCE_BACK_UP_TYPES = [
    {value: 'FINISHED', label: i18n.t('yi-wan-cheng-bei-fen')},
    {value: 'ACKNOWLEDGED', label: i18n.t('wei-wan-cheng-bei-fen-feng-xian-yi-zhi-xiao')},
];

export const AUTH_OPERATIONS = [
    {value: 'VIEW', label: i18n.t('xin-xi-du-qu'), text: i18n.t('xin-xi-du-qu')},
    {value: 'REBOOT', label: i18n.t('zhong-qi'), text: i18n.t('zhong-qi')},
    {value: 'RESET_PASSWORD', label: i18n.t('zhong-zhi-mi-ma'), text: i18n.t('zhong-zhi-mi-ma')},
    {value: 'MODIFY_CONFIG', label: i18n.t('xiu-gai-pei-zhi'), text: i18n.t('xiu-gai-pei-zhi')},
];

export const AUTH_STATUS = [
    {value: 'INIT', text: i18n.t('dai-shou-quan'), tooltip: i18n.t('shou-quan-shen-qing-shang-wei-chu-li')},
    {value: 'AUTHORIZED', text: i18n.t('sheng-xiao-zhong'), tooltip: i18n.t('shou-quan-zai-you-xiao-qi-nei')},
    {value: 'EXPIRED', text: i18n.t('yi-guo-qi'), tooltip: i18n.t('shou-quan-yi-chao-chu-you-xiao-qi')},
    {value: 'REJECTED', text: i18n.t('yi-ju-jue'), tooltip: i18n.t('shou-quan-yi-ju-jue')},
    {value: 'STOPPED', text: i18n.t('yi-ting-zhi'), tooltip: i18n.t('shou-quan-yi-ti-qian-zhong-zhi')},
];

export const AUTH_STATUS_FOR_ICON_MAP = {
    INIT: 'warning',
    AUTHORIZED: 'success',
    EXPIRED: 'waiting',
    REJECTED: 'waiting',
    STOPPED: 'waiting',
};

export const SNAP_SHOT_TYPES = {
    system: i18n.t('xi-tong-pan-kuai-zhao'),
    cds: i18n.t('shu-ju-pan-kuai-zhao'),
};
// 消息类型
export enum MSG_TYPE {
    // 附件消息：只有附件
    ATTACHMENTS = 'ATTACHMENTS',
    // 代码消息
    CODE = 'CODE',
    FB_ORDER = 'FB_ORDER', // 订单信息
}

// LS镜像类型
export const LS_IMAGE_TYPE = {
    ls_template: '自定义',
    lightserver_image: '应用型',
    image: '系统',
};

// 常用工具图标
// OPT: 临时方案，后续需要优化
export const FAVOR_TOOL_ICON_MAP = {
    default: 'bac-icon-tools',
    '示例代码中心': 'bac-icon-code-preview',
    'AI应用详情': 'bac-icon-app-detail',
    '在线错误码查询': 'bac-icon-search-text',
    'BCC健康检查工具': 'bac-icon-service-healthy',
    'BCC端口验通工具': 'bac-icon-port',
    '网站加速工具': 'bac-icon-web-speed-up',
};

export const NOTICE_SCENE_NAME_MAP = {
    waitingFeedBack: i18n.t('dai-nin-fan-kui'),
    waitConfirm: i18n.t('dai-nin-que-ren'),
    autoClose: i18n.t('zi-dong-guan-dan-yu-jing'),
    tsReply: i18n.t('gong-cheng-shi-hui-fu'),
};

export const TIMES = {
    ANY_TIME: i18n.t('ren-yi-shi-jian'),
    WORK_TIME: '9:00-18:00',
    REFUSED: i18n.t('bu-xi-wang-lian-xi'),
};

export const boardConfig = {
    overlayOpacity: 0.5,
    nextBtnText: i18n.t('xia-yi-bu') as string,
    prevBtnText: i18n.t('shang-yi-bu') as string,
    doneBtnText: i18n.t('wo-zhi-dao-le') as string,
    allowClose: true, // 允许关闭
    showProgress: true,
    progressText: '{{current}}/{{total}}',
    stagePadding: 5,
    showButtons: ['next', 'previous', 'close'] as AllowedButtons[],
    onPopoverRender(popover: PopoverDOM) {
        // 强制让arrow居中
        setTimeout(() => {
            if (popover.arrow) {
                popover.arrow.className = popover.arrow.className
                    .replace(/driver-popover-arrow-align-[^\s]+/, 'driver-popover-arrow-align-center');
            }
        }, 30);
        // 去掉默认的关闭按钮的叉号，通过样式控制关闭按钮的样式
        popover.closeButton.innerHTML = '';
    },
};